module.exports = __webpack_public_path__ + "img/20400.ef5b6e82.jpg";